export default __webpack_public_path__ + "assets/images/17f2d6a9514931da74df3fa7f703328e.svg";